export default function toTitleCase(str) {
	return str.replace(/^\w/, d => d.toUpperCase());
}
